export const USER_KEY = 'user';
export const DEVICE_ID_KEY = 'device_id';
export const LOCALE_KEY = 'locale';
export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const CLINIC_KEY = 'clinic';
